import React from "react";

import { IconProps } from "./models";

function MoneyBagIcon(props: IconProps) {
  return (
    <svg
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 497.68 497.68"
      xmlSpace="preserve"
      {...props}
    >
      <path
        fill="#F2B233"
        d="M464.04,404.82c0,97.6-96,92-215.2,92s-215.2,4.8-215.2-92c0-97.6,96-260,215.2-260
  C368.04,145.62,464.04,308.02,464.04,404.82z"
      />
      <path
        fill="#DD981D"
        d="M248.84,145.62c119.2,0,215.2,162.4,215.2,260s-96,92-215.2,92"
      />
      <path
        fill="#F2B233"
        d="M144.04,44.82c0-47.2,47.2-44.8,104.8-44.8s104.8-2.4,104.8,44.8s-47.2,126.4-104.8,126.4
  S144.04,92.02,144.04,44.82z"
      />
      <path
        fill="#DD981D"
        d="M248.84,0.02c57.6,0,104.8-2.4,104.8,44.8s-47.2,126.4-104.8,126.4"
      />
      <path
        fill="#04AF76"
        d="M340.84,154.42c0,8-6.4,14.4-14.4,14.4h-155.2c-8,0-14.4-6.4-14.4-14.4v-4c0-8,6.4-14.4,14.4-14.4
  h156c8,0,14.4,6.4,14.4,14.4v4H340.84z"
      />
      <path
        fill="#008C61"
        d="M168.84,136.82h158.4c8,0,14.4,6.4,14.4,14.4v4c0,8-8,14.4-16,14.4"
      />
      <circle fill="#04AF76" cx="248.84" cy="339.22" r="96" />
      <path
        fill="#008C61"
        d="M180.84,271.22c37.6-37.6,98.4-37.6,136,0s37.6,98.4,0,136"
      />
      <path
        fill="#FFF6E1"
        d="M240.84,416.82v-20c-16-0.8-24.8-4-32-8l4.8-21.6c8,4,18.4,8,30.4,8c10.4,0,17.6-4,17.6-11.2
  s-5.6-11.2-20-16c-20-6.4-32.8-16-32.8-33.6c0-16,7.2-28.8,31.2-32.8v-16.8h16v16c16,0.8,21.6,3.2,27.2,6.4l-4.8,20.8
  c-4.8-2.4-12.8-6.4-26.4-6.4c-12,0-16,4.8-16,10.4c0,6.4,6.4,9.6,22.4,16c21.6,8,30.4,17.6,30.4,34.4s-8.8,30.4-32.8,34.4v20H240.84
  z"
      />
      <g>
        <path
          fill="#FFEEBD"
          d="M248.84,264.82v36.8c0,0,2.4,0,4,0c13.6,0,21.6,4,26.4,6.4l4.8-20.8c-6.4-3.2-11.2-6.4-27.2-6.4v-16
  H248.84z"
        />
        <path
          fill="#FFEEBD"
          d="M259.24,327.22c-4-1.6-8-3.2-10.4-4v27.2c8,4,12.8,8,12.8,13.6c0,6.4-4.8,9.6-12.8,11.2v41.6h8
  v-20.8c24-4,32.8-17.6,32.8-34.4C289.64,344.82,280.84,335.22,259.24,327.22z"
        />
      </g>
    </svg>
  );
}

export default MoneyBagIcon;
